import getLignesCommandesWithReferenceEcheancier
  from '@/services/commande/echeancierFacturation/getLignesCommandesWithReferenceEcheancier';
import getDateDebutFinEchances
  from '@/services/commande/echeancierFacturation/getDateDebutFinEchances';
import checkIfEcheancierWithoutEcheanceFacturer
  from '@/services/commande/echeancierFacturation/checkIfEcheancierWithoutEcheanceFacturer';

export default function updateDatesAllEcheancierAuto(commande) {
  if (!commande.echeanciers) return;
  commande.echeanciers.forEach((echeancier) => {
    if (echeancier.quantitePeriodicite !== 0
      || !checkIfEcheancierWithoutEcheanceFacturer(echeancier)) return;
    const lignes = getLignesCommandesWithReferenceEcheancier(
      commande.lignesCommande, echeancier.referenceEcheancier,
    );
    const date = getDateDebutFinEchances(
      lignes, commande.datePremierAffichage, commande.dateDevisCommande,
    );
    echeancier.dateDebut = date;
    echeancier.dateFin = date;
    echeancier.dateFinPremiereEcheance = date;
  });
}
